import type { Theme } from '@mui/material/styles';
import type { RangeAvailabilityDayVariant } from './types';

import { stylesMode } from 'src/theme/styles';

type PaletteColor = 'info' | 'primary' | 'error';

export const getRangeAvailabilityLegendSx = (theme: Theme, color: PaletteColor) => ({
  bgcolor: theme.vars.palette[color].lighter,
  [stylesMode.dark]: {
    bgcolor: theme.vars.palette[color].darker,
  },
});

export const getRangeAvailabilityLegendLabelSx = (theme: Theme, color: PaletteColor) => ({
  color: theme.vars.palette.text.primary,
  [stylesMode.dark]: {
    color: theme.vars.palette[color].lighter,
  },
});

export const getRangeAvailabilityDayVariantSx = (
  theme: Theme,
  variant: RangeAvailabilityDayVariant
) => {
  const coloredDaySx = (color: PaletteColor) => ({
    bgcolor: theme.vars.palette[color].lighter,
    color: theme.vars.palette.text.primary,
    [stylesMode.dark]: {
      bgcolor: theme.vars.palette[color].darker,
      color: theme.vars.palette[color].lighter,
    },
    '&:hover, &:focus': {
      bgcolor: theme.vars.palette[color].lighter,
      [stylesMode.dark]: {
        bgcolor: theme.vars.palette[color].darker,
      },
    },
  });

  switch (variant) {
    case 'disabled':
      return {
        bgcolor: 'transparent',
        color: theme.vars.palette.text.disabled,
        '&:hover, &:focus': {
          bgcolor: 'transparent',
        },
      };
    case 'window':
      return coloredDaySx('info');
    case 'preferred':
      return coloredDaySx('primary');
    case 'excluded':
      return coloredDaySx('error');
    case 'selected':
      return {
        bgcolor: theme.vars.palette.text.primary,
        color: theme.vars.palette.common.white,
        [stylesMode.dark]: {
          color: theme.vars.palette.grey[800],
        },
        '&:hover, &:focus': {
          bgcolor: theme.vars.palette.text.primary,
        },
      };
    default:
      return {};
  }
};

export const getRangeAvailabilityDayDisabledOverrideSx = (
  theme: Theme,
  variant: RangeAvailabilityDayVariant
) => {
  if (variant !== 'excluded' && variant !== 'disabled') {
    return undefined;
  }

  const baseSx = getRangeAvailabilityDayVariantSx(theme, variant);

  return {
    '&.Mui-disabled': {
      ...baseSx,
      opacity: 1,
    },
  };
};
